import { isNotNullish } from '@nx/stdlib';

import type { AuraDatabaseAvailableActions, AuraDatabaseCapabilities, INSTANCE_STATUS } from '../console.types';

export type DatabaseParam = {
  instanceId: string;
  id: string;
};

export type DatabaseSummary = {
  aura_database_id: string;
  instance_id: string;
};

export type DatabaseDetails = DatabaseSummary & {
  name: string;
  status: INSTANCE_STATUS;
  nodes?: number;
  relationships?: number;
  capabilities: AuraDatabaseCapabilities;
  available_actions: AuraDatabaseAvailableActions;
  created_at?: string;
};

export type NewDatabase = DatabaseDetails & {
  bolt_url: string;
};

export type ListDatabasesResponse = { data: DatabaseSummary[] };
export type GetDatabaseResponse = { data: DatabaseDetails };
export type CreatedDatabaseResponse = { data: NewDatabase };

const isDatabaseSummary = (response: unknown): response is DatabaseSummary => {
  return (
    isNotNullish(response) &&
    'aura_database_id' in response &&
    'instance_id' in response &&
    typeof response.aura_database_id === 'string' &&
    typeof response.instance_id === 'string'
  );
};

export const isListDatabasesResponse = (response: unknown): response is ListDatabasesResponse => {
  return (
    isNotNullish(response) &&
    'data' in response &&
    Array.isArray(response.data) &&
    response.data.every(isDatabaseSummary)
  );
};

const isDatabaseDetails = (details: unknown): details is DatabaseDetails => {
  return (
    isNotNullish(details) &&
    'aura_database_id' in details &&
    'instance_id' in details &&
    'name' in details &&
    'status' in details &&
    'capabilities' in details &&
    'available_actions' in details &&
    typeof details.aura_database_id === 'string' &&
    typeof details.instance_id === 'string' &&
    typeof details.name === 'string' &&
    typeof details.status === 'string' &&
    typeof details.capabilities === 'object' &&
    typeof details.available_actions === 'object'
  );
};

export const isGetDatabaseResponse = (response: unknown): response is GetDatabaseResponse => {
  return isNotNullish(response) && 'data' in response && isDatabaseDetails(response.data);
};
